import React from 'react';
import { Link } from 'react-router-dom';
import InstagramIcon from '@mui/icons-material/Instagram';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { blogPosts } from './blog-data';

export default function BlogPage() {
	return (
		<div className="pt-20 lg:pt-24 pb-16">
			<div className="relative overflow-hidden bg-gradient-to-br from-gray-50 via-white to-primary-50 py-16 lg:py-24">
				<div className="absolute inset-0 overflow-hidden pointer-events-none">
					<div className="absolute -top-20 -right-20 w-96 h-96 bg-primary-100/50 rounded-full blur-3xl" />
					<div className="absolute bottom-0 left-0 w-72 h-72 bg-accent-100/30 rounded-full blur-3xl" />
				</div>
				<div className="relative max-w-4xl mx-auto px-6 text-center">
					<span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-bold mb-5 tracking-widest uppercase">
						BLOG
					</span>
					<h1 className="font-playfair-custom-bold text-5xl lg:text-6xl text-gray-900 mb-4">
						Artykuły i <span className="text-gradient">porady</span>
					</h1>
					<p className="text-gray-500 font-montserrat-custom-medium text-lg max-w-xl mx-auto">
						Praktyczne wskazówki dotyczące treningu, diety i zdrowego stylu życia prosto od Amelii.
					</p>
				</div>
			</div>

			<div className="max-w-6xl mx-auto px-4 sm:px-6 mt-16">
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
					{blogPosts.map((post) => (
						<Link
							key={post.id}
							to={`/blog/${post.slug}`}
							className="group bg-white rounded-3xl shadow-soft hover:shadow-soft-lg transition-all duration-500 hover:-translate-y-2 overflow-hidden flex flex-col"
						>
							<div className={`relative bg-gradient-to-br ${post.gradient} h-52 flex items-end p-6 overflow-hidden`}>
								<div className="absolute top-0 right-0 text-white/10 font-playfair-custom-bold text-[120px] leading-none select-none translate-x-4 -translate-y-4 transition-transform duration-500 group-hover:translate-x-0 group-hover:-translate-y-6">
									{post.number}
								</div>
								<div className="relative z-10">
									<span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm text-white text-xs font-bold rounded-full mb-3 border border-white/20">
										{post.category}
									</span>
									<h2 className="font-playfair-custom-bold text-xl text-white leading-snug">
										{post.title}
									</h2>
								</div>
							</div>

							<div className="p-6 flex flex-col flex-grow">
								<div className="flex items-center gap-3 text-gray-400 text-xs font-montserrat-custom-medium mb-4">
									<AccessTimeIcon sx={{ fontSize: 14 }} />
									<span>{post.readTime} czytania</span>
									<span className="text-gray-300">·</span>
									<span>{post.date}</span>
								</div>

								<p className="text-gray-500 text-sm leading-relaxed font-montserrat-custom-medium flex-grow mb-5">
									{post.excerpt}
								</p>

								<div className="flex items-center gap-1.5 text-primary-600 text-sm font-bold font-montserrat-custom-medium group-hover:gap-3 transition-all duration-300">
									CZYTAJ WIĘCEJ
									<ArrowForwardIcon sx={{ fontSize: 16 }} />
								</div>
							</div>
						</Link>
					))}
				</div>

				<div className="mt-16">
					<div className="relative bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl overflow-hidden">
						<div className="absolute inset-0 overflow-hidden">
							<div className="absolute -top-20 -right-20 w-80 h-80 bg-primary-500/10 rounded-full blur-3xl" />
							<div className="absolute bottom-0 left-0 w-64 h-64 bg-accent-500/10 rounded-full blur-3xl" />
						</div>
						<div className="relative p-10 lg:p-16 flex flex-col lg:flex-row items-center gap-10 text-white">
							<div className="flex-grow text-center lg:text-left">
								<h3 className="font-playfair-custom-bold text-3xl lg:text-4xl mb-3">
									Więcej treści na Instagramie
								</h3>
								<p className="text-gray-400 font-montserrat-custom-medium max-w-md">
									Regularnie publikuję posty i relacje o treningu, diecie i zdrowym stylu życia. Obserwuj, żeby nie przegapić!
								</p>
							</div>
							<div className="flex-shrink-0">
								<a
									href="https://www.instagram.com/amelia_palczynska"
									target="_blank"
									rel="noopener noreferrer"
									className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-primary-500 to-primary-600 text-white font-bold rounded-full shadow-soft-lg hover:shadow-card-hover hover:scale-105 transition-all duration-300"
								>
									<InstagramIcon />
									@amelia_palczynska
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
